module.exports = __webpack_public_path__ + "media/images/emblems/Mutrux-coat_of_arms-939e7fd1c284374aa90a761393285df2.svg";